export default __webpack_public_path__ + "static/media/Adventure.067102d0.svg";